import axios from 'axios'
import Qs from 'qs'
// import router from '@/router'
import { Toast } from 'vant';
import { throttle, filterParams, globalObj, login } from "./index";

const DefaultUrl = process.env.VUE_APP_BASE_API

// 创建axios实例
const request = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: DefaultUrl,
  // 超时
  timeout: globalObj.timeout,
})

//防止登录token过期后弹出多次提示框
const reLogin = throttle(function (val) {
  globalObj.setToken('')
  Toast(val || '请重新登录！')
  setTimeout(() => {
    login()
  }, 300)
}, 5000)

const tip = throttle(function (val) {
  Toast(val || '请求错误')
}, 3000)

// request拦截器
request.interceptors.request.use(
  config => {
    const timestamp = new Date().getTime()
    const noTokenUrl = []
    if (globalObj.getToken() && noTokenUrl.indexOf(config.url) === -1) {
      config.headers['accessToken'] = globalObj.getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 基础请求头
    Object.assign(config.headers, {
      'timestamp': timestamp,
      'appChannel': 'default_channel',
      'appClient': 'H5'
    })

    // 环境类型和版本信息
    const envType = globalObj.getEnvType()
    if (envType) {
      config.headers['osType'] = envType.split('_')[1] || 'H5'
    }

    const appVersion = globalObj.getAppVersion()
    if (appVersion) {
      config.headers['appVersionCode'] = appVersion
    }

    // 网络头部信息
    const networkHeaderStr = localStorage.getItem('networkHeader')
    let networkHeader = {}
    if (networkHeaderStr) {
      try {
        networkHeader = JSON.parse(networkHeaderStr)
        // 批量设置网络头部字段
        const networkFields = ['osVersion', 'language', 'appSymbol', 'appId']
        networkFields.forEach(field => {
          if (networkHeader[field]) {
            config.headers[field] = networkHeader[field]
          }
        })
      } catch (e) {
        console.warn('解析 networkHeader 失败:', e)
      }
    }

    // 应用名称
    const appName = localStorage.getItem('appName') ||
      (networkHeader.appName ? decodeURIComponent(networkHeader.appName) : '')
    if (appName) {
      config.headers['appName'] = appName
    }

    return config
  },
  error => {
    Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  res => {
    const status = res.status
    const data = res.data
    const code = data.code || 0
    if (status !== 200 && status !== 304) {
      Toast(data.message)
      return Promise.reject(res)
    }
    if (code === 10002) {
      reLogin(data.message)
      return Promise.reject(res)
    } else if (code !== 200) {
      tip(data.message)
      return Promise.reject(res)
    } else {
      return data
    }
  },
  error => {
    const tip = function () {
      Toast(error.message)
    }
    throttle(tip, 5000)()
    return Promise.reject(error)
  }
)

export const Request = (url, methods, params, type) => {
  request.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'
  // 过滤处理参数
  const query = {
    url: url,
    method: methods,
    timeout: type === 'export' ? 0 : globalObj.timeout
  }
  if (methods === 'get') {
    query.params = filterParams(params)
  } else {
    //当有type参数时表示formdata类型数据
    if (type === 'formData') {
      request.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      query.data = Qs.stringify(filterParams(params))
    } else {
      query.data = filterParams(params)
    }
  }
  return request(query)
}

export default Request
